<template>
  <div id="button-bar">
    <span v-show="hasErrors" class="error">{{ $t("button_bar.error") }}</span>
    <br />
    <button @click="savePdf">{{ $t("button_bar.print_button.label") }}</button>
    <button v-show="docxIsVisible" @click="saveDocx">
      {{ $t("button_bar.docx_button.label") }}
    </button>
  </div>
</template>

<script>
import htmlDocx from "html-docx-js/dist/html-docx";
import { saveAs } from "file-saver";

export default {
  props: {
    docxIsVisible: Boolean,
  },
  data() {
    return {
      hasErrors: false,
    };
  },
  methods: {
    formIsValid() {
      let form = document.getElementById("form");

      let inputFieldsNotEdited = form.getElementsByClassName("not-changed");
      if (inputFieldsNotEdited.length > 0) {
        for (let i = 0; i < inputFieldsNotEdited.length; i++) {
          inputFieldsNotEdited[i].classList.add("is-invalid");
          inputFieldsNotEdited[i].setCustomValidity("not edited");
        }
      }

      form.classList.add("was-validated");
      return form.checkValidity();
    },

    savePdf() {
      if (this.formIsValid()) {
        window.focus();
        print.call(window);
        this.hasErrors = false;
        return;
      }
      this.hasErrors = true;
    },

    saveDocx() {
        const contractContent = document.getElementById("contract").innerHTML;
        const contractDocument =
          '<!DOCTYPE html><html><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"></head><body>' +
          contractContent +
          "</body></html>";
        const contractDocx = htmlDocx.asBlob(contractDocument);
        saveAs(contractDocx, "kontrakt.docx");
        this.hasErrors = false;
        return;
    },
  },
};
</script>

<style>
#button-bar {
  text-align: center;
  margin-top: 0.5rem;
}

#button-bar > button {
  border: none;
  padding: 1rem;
  margin-bottom: 0.2rem;
  width: 200px;
}

.error {
  margin: 15px;
  padding: 15px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/shared/components/ButtonBar.vue